import React, { useState, useEffect} from "react";
import { IListProviderProps } from "../types/IListProviderProps";
import { ArchiveListContext } from "./contexts/ArchiveListContext";

import ApiService from "../services/ApiServiceClass";

import { useLoader } from "../hooks/useLoader";

import { useAuth } from "../hooks/useAuth";

interface IMemberType {
    name: string,
    is_primary: boolean
}

interface IRequestType {
    id: number,
    members: IMemberType[],
    description: string,
    submitted_on: Date,
    status: string,
    total_cost: number
}


const ArchivedListProvider: React.FC<IListProviderProps> = ({children}) => {
    const [ allRequestList, setAllRequestList ] = useState<any[]>([]);
    const [ newRequestList, setNewRequestList ] = useState<any[]>([]);
    const [ approvedRequestList, setApprovedRequestList ] = useState<any[]>([]);
    const [ waitListedList, setWaitListedList] = useState<any[]>([]);
    const [ orderedList, setOrderedList] = useState<any[]>([]);
    const [ purchasedList, setPurchasedList] = useState<any[]>([]);
    const [ deliveredList, setDeliveredList] = useState<any[]>([]);
    const [ declinedList, setDeclinedList] = useState<any[]>([]);

    const [allRequestListCount, setAllRequestListCount] = useState(0);
    const [approvedRequestListCount, setApprovedRequestListCount] = useState(0);
    const [newRequestListCount, setNewRequestListCount] = useState(0);
    const [waitListedListCount, setWaitListedListCount] = useState(0);
    const [orderedListCount, setOrderedListCount] = useState(0);
    const [purchasedListCount, setPurchasedListCount] = useState(0);
    const [deliveredListCount, setDeliveredListCount] = useState(0);
    const [declinedListCount, setDeclinedListCount] = useState(0);
    
    const auth = useAuth();
    
    const loader = useLoader();

    const fetchList = async () => {
        
        let maxbudget = 0;

        if (auth?.roles?.find(role => ["200"]?.includes(role))) {
            maxbudget = 900000000;
        } else {
            maxbudget = 900000000;
        }
        
        loader?.setIsLoading(true);        
        try {
            const responseData = await ApiService.getArchivedRequestForApproval(maxbudget);

            console.log("ArchivedListProvider.tsx | line 63");
            console.log(responseData);
            
            loader?.setIsLoading(false);

            const waitListedRequests = responseData.data.filter((request: IRequestType) => request.status == "Waitlisted");
            setWaitListedList(waitListedRequests);
            setWaitListedListCount(waitListedRequests.length);

            const newRequests = responseData.data.filter((request: IRequestType) => request.status == "New");
            setNewRequestList(newRequests);
            setNewRequestListCount(newRequests.length);            

            const approvedRequests = responseData.data.filter((request: IRequestType) => request.status == "Approved");
            setApprovedRequestList(approvedRequests);
            setApprovedRequestListCount(approvedRequests.length);

            const orderedRequests = responseData.data.filter((request: IRequestType) => request.status == "Ordered");
            setOrderedList(orderedRequests);
            setOrderedListCount(orderedRequests.length);

            const purchasedRequests = responseData.data.filter((request: IRequestType) => request.status == "Purchased");
            setPurchasedList(purchasedRequests);
            setPurchasedListCount(purchasedRequests.length);

            const deliveredRequests = responseData.data.filter((request: IRequestType) => request.status == "Delivered");
            setDeliveredList(deliveredRequests);
            setDeliveredListCount(deliveredRequests.length);            

            const declinedRequests = responseData.data.filter((request: IRequestType) => request.status == "Declined");
            setDeclinedList(declinedRequests);
            setDeclinedListCount(declinedRequests.length);                        
            
            const allRequests = [...newRequests, ...waitListedRequests, ...approvedRequests, ...orderedRequests, ...purchasedRequests, ...deliveredRequests, ...declinedRequests];
            setAllRequestList(allRequests);
            setAllRequestListCount(allRequests.length);            

        } catch(error) {
            loader?.setIsLoading(false);
        }
    }

    return (
        <ArchiveListContext.Provider value={{  allRequestList,
                                        newRequestList, 
                                        approvedRequestList,
                                        waitListedList, 
                                        orderedList,
                                        purchasedList,
                                        deliveredList,
                                        declinedList,
                                        allRequestListCount,
                                        newRequestListCount, 
                                        waitListedListCount,
                                        approvedRequestListCount,
                                        orderedListCount,
                                        purchasedListCount,
                                        deliveredListCount,
                                        declinedListCount,
                                        setOrderedList,
                                        setDeclinedList,
                                        setDeliveredList,
                                        setPurchasedList,
                                        setAllRequestList, 
                                        setNewRequestList, 
                                        setWaitListedList, 
                                        setNewRequestListCount, 
                                        setWaitListedListCount, 
                                        setOrderedListCount,
                                        setPurchasedListCount,
                                        setDeliveredListCount,
                                        setDeclinedListCount,
                                        fetchList
                                    }}>
            { children }
        </ArchiveListContext.Provider>
    )
}

export default ArchivedListProvider;